import api from './api';

export const getEquipments = async () => {
  const res = await api.get('/equipment');
  return res.data;
};

export const addEquipment = async (mac, location) => {
  const res = await api.post('/equipment/add', { mac, location });
  return res.data;
};

export const removeEquipment = async (mac) => {
  const res = await api.post('/equipment/remove', { mac });
  return res.data;
};


